<pathPantalla></pathPantalla>

<div [hidden]="consulta">
    <!-- Filtros -->
    <div class="row">
        <div class="col-lg-12" style="padding: 0px">
            <section class="widget">
                <!-- título -->
                <header>
                    <h3> {{sistemaService.NombrePantallaActual}} </h3>
                </header>
                <div class="separador"></div>
                <filtros (filtroAplicado)="SetDatos($event)" [filtros]="filtrosDisplay" [urlApi]="uriApi" #filtrosComponent></filtros>
            </section>
        </div>
    </div>

    <div class="divisor8"></div>

    <div class="row">
        <div class="col-lg-12" style="padding: 0px">
            <section class="widget">
                <!-- tabla -->
                <div>

                    <div class="divisor16"></div>

                    <!-- datos -->
                    <dx-data-grid
                        (onOptionChanged)="sistemaService.CambiarPaginacionTabla($event)"
                        id="tabla"
                        [columnAutoWidth]="true"
                        [dataSource]="dataTable"
                        [noDataText]="'Sin Datos'"
                        [showColumnHeaders]="true"
                        >
                        <dxo-export [enabled]="true" [fileName]="sistemaService.NombrePantallaActual" matTooltip="Todo"></dxo-export>

                        <dxo-search-panel
                            [visible]="true"
                            [width]="240"
                            placeholder="{{'Buscar' | translate}}">
                        </dxo-search-panel>

                        <dxo-paging [pageSize]="sistemaService.tablaPaginacion"></dxo-paging>
                        <!--<dxo-scrolling mode="virtual" [useNative]="false" [showScrollbar]="'always'"></dxo-scrolling>-->
                        <dxo-header-filter [visible]="true"></dxo-header-filter>
                        <dxo-pager
                            [visible]="true"
                            [allowedPageSizes]="sistemaService.tablaPaginacionPaginaSize"
                            [displayMode]="sistemaService.tablaPaginacionModo"
                            [showPageSizeSelector]="sistemaService.tablaPaginacionSelector"
                            [showInfo]="sistemaService.tablaPaginacionInfo"
                            [showNavigationButtons]="sistemaService.tablaPaginacionNavegacion">
                        </dxo-pager>

                        <dxi-column
                            [allowExporting]="false"
                            caption="Acciones"
                            cellTemplate="cellAcciones"
                            alignment="center"
                            [minWidth]="120">

                        </dxi-column>
                        <dxi-column
                            dataField="departamentojefe"
                            caption="Departamento">
                        </dxi-column>
                        <dxi-column
                            dataField="totalacuerdo" format="fixedPoint" alignment="center"
                            caption="Acuerdos totales">
                        </dxi-column>
                        <dxi-column
                            dataField="firmado" format="fixedPoint" alignment="center"
                            caption="Acuerdos firmados">
                        </dxi-column>
                        <dxi-column
                            dataField="faltante" format="fixedPoint" alignment="center"
                            caption="Acuerdos pendientes">
                        </dxi-column>
                        <dxi-column
                            dataField="avance" alignment="center"
                            caption="% de avance">
                        </dxi-column>
                        <!-- Acciones -->
                        <div *dxTemplate="let cell of 'cellAcciones'">
                            <a matTooltip="Ver" class="tablaBoton" (click)="Formulario(2, cell.data)">
                                <i class="fa fa-eye fa-lg" aria-hidden="true"></i>
                            </a>
                        </div>

                    </dx-data-grid>

                </div>
            </section>
        </div>
    </div>
</div>

<div #containerFormulario></div>
